import React from 'react';
import './Footer.css'
import FNav from '../Common/FNav';


const Footer = () => {
    return ( 
        <footer>
            <div className='FooterTop'>
                <div className='FCol'>
                    <p className='FLogo'>PLATO</p>
                    <p className='Date'>427 - 347 BCE</p>
                </div>

                <div className='FCol'>
                    <p className='FooterQuote'>
                        "There will be no end to the troubles of states, or of humanity itself, till philosophers become kings of this world."
                    </p>
                    <p className='Name'>
                        — Plato, The Republic
                    </p>
                </div>

                <div className='FCol'>
                    <FNav />
                </div>
            </div>
        </footer>
     );
}
 
export default Footer;